import { useMemo } from "react";

import { useDataLayerQuery } from "#/hooks/useDataLayer";
import { BreedingValuesComparisonGeneticTrendService } from "#/pages/breeding-values/BreedingValuesComparisonGeneticTrendService";

/**
 * Custom hook for Breeding Values Comparison Genetic Trend Query.
 * Uses the BreedingValuesComparisonGeneticTrendService to perform POST queries.
 *
 * @returns {object} The data layer query object (result, isLoading, error, query, reload).
 */
export function useBreedingValuesComparisonGeneticTrendQuery() {
  const service = useMemo(
    () => new BreedingValuesComparisonGeneticTrendService(),
    []
  );

  return useDataLayerQuery({
    ident: "breeding-values-comparison-genetic-trend",
    dataLayer: service,
  });
}
